import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  ButtonWrap,
  ContentWrap,
  ErrorMessageWrap,
  Hr,
  InputTitle,
  InputWrap,
  LoginWrap,
  Main,
  RegisterTitle,
  RegisterWrap,
  TitleWrap,
} from "./LoginStyle";
import "./Login.css";
import { Input } from "antd";
import { getLoginInfo } from "../../Service/API";
import Logo from "../Components/assets/logo.png";

const Login = () => {
  const navigate = useNavigate();
  const [id, setId] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const loginChk = async () => {
    try {
      const response = await getLoginInfo(id, password);
      const { token, userId, userName, userDiv } = response; // 반환된 데이터에서 토큰과 사용자 정보 추출

      if (token) {
        localStorage.setItem("authToken", token); // 토큰 저장
        localStorage.setItem("userId", userId); // userId 저장
        localStorage.setItem("userName", userName); // userName 저장
        localStorage.setItem("userDiv", userDiv); // userDiv 저장

        window.location.reload(true);

        navigate("/HOME"); // 로그인 성공 시 홈으로 이동
      } else {
        setErrorMessage(
          "로그인에 실패했습니다. 아이디와 비밀번호를 확인하세요."
        );
      }
    } catch (error) {
      setErrorMessage(
        "로그인에 실패했습니다.아이디 또는 비밀번호를 확인해주세요."
      );
    }
  };

  return (
    <Main>
      <img src={Logo} width="180px" style={{ margin: "20px 0px 0px 20px" }} />
      <LoginWrap>
        <TitleWrap>
          <br />
          스마트 낙농단지
        </TitleWrap>
        <ContentWrap>
          <InputTitle>아이디</InputTitle>
          <InputWrap>
            <Input
              type="text"
              className="input"
              placeholder="아이디를 입력하세요."
              value={id}
              onChange={(e) => setId(e.target.value)}
            />
          </InputWrap>
          <br />
          <InputTitle>비밀번호</InputTitle>
          <InputWrap>
            <Input
              type="password"
              className="input"
              placeholder="비밀번호를 입력하세요."
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </InputWrap>

          <ErrorMessageWrap>
            {errorMessage && <p>{errorMessage}</p>}
          </ErrorMessageWrap>
        </ContentWrap>

        <ButtonWrap>
          <button className="bottomButton" onClick={loginChk}>
            로그인
          </button>
        </ButtonWrap>
        <Hr />
        <RegisterWrap>
          <RegisterTitle>당진낙농축협</RegisterTitle>
        </RegisterWrap>
        <RegisterWrap>
          <RegisterTitle>
            Copyright 2024. 에이아이에스(주) inc. all rights reserved
          </RegisterTitle>
        </RegisterWrap>
      </LoginWrap>
    </Main>
  );
};

export default Login;
